import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { MgStreamScrollerModule } from '@app/src/app/components/MgStreamScroller';
import { MgContentLinkModule } from '@app/src/app/content-link';
import { MgAvatarModule } from '@app/src/app/elements/MgAvatar';
import { MgPersonMinimalModule } from '@app/src/app/elements/MgPersonMinimal';
import { MgIconModule } from '@app/src/app/icon';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgPipesModule } from '@app/src/app/pipes';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { GenericButtonModule } from '@shared/components/button';
import { FormModule } from '@shared/components/form';
import { TextModule } from '@shared/components/text/text.module';

import { GenericModule } from '../../../shared/components/generic/generic.module';
import { PointsLeaderboardComponent } from './PointsLeaderboard.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgStreamScrollerModule,
    MgIconModule,
    MgPipesModule,
    MgContentLinkModule,
    PermissionsModule,
    MgEmptyStateModule,
    MgAvatarModule,
    MgPersonMinimalModule,
    MgSpinnerModule,
    GenericButtonModule,
    FormModule,
    TextModule,

    // External dependencies
    CommonModule,
    TranslateModule,
    MatRippleModule,
    FlexLayoutModule,
    RouterModule,
    GenericModule,
  ],
  declarations: [PointsLeaderboardComponent],
  exports: [PointsLeaderboardComponent],
})
export class PointsLeaderboardModule {}
